import React from "react"
import { useSelector } from "react-redux"

const NewsScene = ({ news }) => {
    const newsData = useSelector(state => state.game.currentNarrativeObject.news[`${news}`])
    const { headline, content, src } = newsData

    return (
        <article className='gray-container md:mb-0'>
            <div className='w-full'>
                <h4 className='headlineStyle pt-2'>{headline}</h4>
                <hr className='mb-4' />
                <p className='pb-2'>{content}</p>
                <hr className='mb-2' />
                <p className='src-legend p-0'><a href={src} target='_blank' rel="noopener noreferrer">fonte: {src}</a></p>
            </div>
        </article>
    )
}

export default NewsScene
